// eslint-disable-next-line no-underscore-dangle
var isImgNode = function isImgNode(node) {
  return node.type.__isImgNode === true;
};
export default isImgNode;